import React from 'react';
import styled from 'styled-components';
import StyleConfig from 'src/constants/StyleConfig';
import { ArrowRightIcon } from 'src/components/atoms/icon/ArrowIcon';
import ListText from 'src/components/atoms/list/ListText';
import Bar from 'src/components/atoms/shapes/Bar';

interface Props {
  clickEvent?: Function;
  listText: string;
  listColor: 'primary' | 'secondary';
  hasEmptyLine?: boolean;
}

export const ListBlock = ({ ...props }: Props) => {
  return (
    <Styled
      onClick={() => {
        if (props.clickEvent) props.clickEvent();
      }}
    >
      <div className="inner">
        <div className="left">
          <ListText text={props.listText} />
        </div>
        <div className="right">
          <ArrowRightIcon color={props.listColor} />
        </div>
      </div>
      {!props.hasEmptyLine ? (
        <div className="margin">
          <Bar />
        </div>
      ) : null}
    </Styled>
  );
};

const Styled = styled.div`
  background-color: #fff;
  box-sizing: border-box;
  > .inner {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: ${StyleConfig.HELPER.M16};
    .left {
      width: 96%;
    }
  }
  > .margin {
    margin: 0 ${StyleConfig.HELPER.M16};
  }
`;
export default ListBlock;
